import { Action } from "../../../actions/actions";
import { HallsActionTypes } from "../actions/actionTypes";
import Moment from "moment";

export function specificationUploading(state: boolean = false, action: Action) {
    switch (action.type) {
        case HallsActionTypes.UPLOAD_SYSTEM_SPECIFICATION:
            return true;
        case HallsActionTypes.UPLOAD_SYSTEM_SPECIFICATION_SUCCESS:
        case HallsActionTypes.UPLOAD_SYSTEM_SPECIFICATION_FAIL:
            return false;
        default:
            return state;
    }
}

export function specificationUploaded(state: boolean = false, action: Action) {
    switch (action.type) {
        case HallsActionTypes.REMOVED_SPECIFICATION_SELECTION:
            return false;
        case HallsActionTypes.UPLOAD_SYSTEM_SPECIFICATION_SUCCESS:
            return true;
        default:
            return state;
    }
}

export function specificationActivities(state: any = {}, action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_SPECIFICATION_ACTIVITY:
            return action.payload.page == 0 ? {} : state;
        case HallsActionTypes.GET_SPECIFICATION_ACTIVITY_SUCCESS:
            let currentActivities = [];
            if (
                state.unprocessedActivities &&
                state.unprocessedActivities.length > 0 &&
                state.serverId == action.payload.serverId
            ) {
                currentActivities = [...state.unprocessedActivities];
            }

            currentActivities = currentActivities.concat(
                action.payload.activities
            );

            const results = currentActivities.reduce((acc, obj) => {
                const updateDate = Moment(obj.inserted_at).format(
                    "DD MMM YYYY"
                );
                if (!acc[updateDate]) {
                    acc[updateDate] = [obj];
                } else {
                    acc[updateDate].unshift(obj);
                }
                return acc;
            }, {});
            let latestSpecVersion = currentActivities[0] || null;
            if(latestSpecVersion){
              let last_config_version = currentActivities[0].specs.config_version
              currentActivities.map(act => {
                if(act.specs.config_version>last_config_version){
                  last_config_version = act.specs.config_version
                  latestSpecVersion = act
                }
                })
            }
            return {
                currentSpec: latestSpecVersion,
                activities: results,
                unprocessedActivities: state.unprocessedActivities
                    ? state.unprocessedActivities.concat(
                          action.payload.activities
                      )
                    : action.payload.activities,
                serverId: action.payload.serverId,
                finished: action.payload.activities.length < 12 ? true : false
            };
        case HallsActionTypes.GET_SPECIFICATION_ACTIVITY_FAIL:
        default:
            return state;
    }
}

export function specificationActivitiesPage(state: number = 0, action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_SPECIFICATION_ACTIVITY:
            return action.payload.page;
        default:
            return state;
    }
}

export function specificationActivitiesLoading(
    state: boolean = false,
    action: Action
) {
    switch (action.type) {
        case HallsActionTypes.GET_SPECIFICATION_ACTIVITY:
            return true;
        case HallsActionTypes.GET_SPECIFICATION_ACTIVITY_SUCCESS:
        case HallsActionTypes.GET_SPECIFICATION_ACTIVITY_FAIL:
            return false;
        default:
            return state;
    }
}
